<template>
  <transition name="fade">
    <div class="value-container" :class="{ updateValue: updating }">
      <span
        >{{ content }}
        <span v-if="unit && content !== '--'">{{ unit }}</span>
      </span>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'AnimatedNumber',
  props: {
    value: {
      default: 'n/a'
    },
    unit: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      content: this.value,
      updating: false
    };
  },
  watch: {
    /**
     * This watcher will be used to determine whether we animate
     * the background-color in order to let users know that something
     * has changed.
     *
     * @param newVal
     * @param oldVal
     */

    value(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.updating = true;
        this.content = newVal;
      }

      setTimeout(() => {
        this.updating = false;
      }, 450);
    }
  }
};
</script>

<style scoped lang="scss">
.value-container {
  span {
    transition: background-color 0.5s;
    background-color: white;

    @include textCharts;
    color: $petrol;
    display: inline-block;
    word-break: break-all;
  }
}

.updateValue span {
  background-color: $greeny-blue;
}
</style>
